import {Router} from '@angular/router';
import {Inject, Injectable} from '@angular/core';
import {catchError, from, map, Observable, of, switchMap, throwError} from 'rxjs';
import {ClearingTicketCustomService, LIGHT_PARTNER_API_PATH} from '@adlatus-gui/domain/clearing-custom';
import {isLightRoute} from "@adlatus-gui/shared";


@Injectable({
  providedIn: 'root'
})
export class LightPartnerService {

  constructor(
    private router: Router,
    private clearingTicketCustomService: ClearingTicketCustomService,
    @Inject(LIGHT_PARTNER_API_PATH) private lightPartnerApiPath: string) {
  }

  getIsLightPartner() {
    return isLightRoute();
  }

  getIsLightPartnerRoute() {
    return isLightRoute();
  };

  getLightPartnerItuCode(ticketId: string): Observable<string | null> {
    return from(this.clearingTicketCustomService.getOwnerCode(ticketId)).pipe(
      map(ownerCode => {
        return ownerCode;
      }),
      catchError(error => {
        console.error('Error fetching owner code:', error);
        // Return null instead of throwing error
        return of(null);
      })
    );
  }

  applyLightPartnerApi(basePath: string) {
    return basePath + this.lightPartnerApiPath;
  };
}


